import { useSelector } from 'react-redux';
import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';

// Entity adapter for sections and pages
const viewCourseAdapter = createEntityAdapter();

// Selectors moved from viewCourseSlice
export const {
  selectAll: selectCourseSections,
  selectById: selectCourseSectionById,
} = viewCourseAdapter.getSelectors((state) => state.viewCourse.sections);

export const {
  selectAll: selectCoursePages,
  selectById: selectCoursePageById,
} = viewCourseAdapter.getSelectors((state) => state.viewCourse.pages);

// Basic selectors
export const selectTocMenuIsClosed = state => state.viewCourse.tocMenuIsClosed;
export const selectCurrentPageId = state => state.viewCourse.currentPageId;
export const selectCurrentCourseId = state => state.viewCourse.currentCourseId;
export const selectCurrentSectionId = state => state.viewCourse.currentSectionId;
export const selectNextAvailablePageId = state => state.viewCourse.nextAvailablePageId;
export const selectLastUnlockedPageId = state => state.viewCourse.lastUnlockedPageId;

// Complex selectors
const selectSectionId = (_, sectionId) => sectionId;
export const selectPagesBySection = createSelector(
  [selectCoursePages, selectSectionId],
  (pages, sectionId) => pages?.filter((item) => item.sectionId === sectionId)
);

// State hooks
export const useTocMenuIsClosed = () => useSelector(selectTocMenuIsClosed);
export const useCurrentPageId = () => useSelector(selectCurrentPageId);
export const useCurrentCourseId = () => useSelector(selectCurrentCourseId);
export const useCurrentSectionId = () => useSelector(selectCurrentSectionId);
export const useNextAvailablePageId = () => useSelector(selectNextAvailablePageId);
export const useLastUnlockedPageId = () => useSelector(selectLastUnlockedPageId);
export const useCourseSections = () => useSelector(selectCourseSections);
export const useCoursePages = () => useSelector(selectCoursePages);
export const useCourseSectionById = (sectionId) => useSelector(state => selectCourseSectionById(state, sectionId));
export const useCoursePageById = (pageId) => useSelector(state => selectCoursePageById(state, pageId));
export const usePagesBySection = (sectionId) => useSelector(state => selectPagesBySection(state, sectionId));

// Export the adapter for use in the state slice
export { viewCourseAdapter };

// Page-related selectors and hooks
export const selectPage = state => state.coursePage.data;
export const selectPageStatus = state => state.coursePage.status;

// Page state hooks
export const usePage = () => useSelector(selectPage);
export const usePageStatus = () => useSelector(selectPageStatus);
